import '../style/Home.css';
// import React from "react";
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Container } from 'react-bootstrap';
import { AuthContext } from '../App';
import { Row, Col } from "react-bootstrap";
// import ReactPlayer from 'react-player';
import { Toast } from 'react-bootstrap';
import { apiFetchJson } from '../api';




const SimulationMovieUpload = ({ study, user }) => {
    // const [dispState, dispatchState] = useReducer(selectReducer, {
    //     simulations: study.simulations
    // });

    const { state: authState, dispatch: authDispatch } = React.useContext(AuthContext);
    const [submitting, setSubmitting] = useState(false);
    const [status, setStatus] = useState(undefined);
    const [message, setMessage] = useState('');

    const [showToast, setShowToast] = useState(false);
    const toggleToast = () => setShowToast(!showToast);
    const [selectedSimulationID, setSelectedSimulation] = useState(undefined);
    const [isSimSelected, setIsSimSelected] = useState(false);



    const handleSubmitMovie = event => {
        event.preventDefault();
        setSubmitting(true);
        let input = document.getElementById('movieFileUpload');
        const body = new FormData();
        body.append('file', input.files[0]);

        console.log('uploading movie for ', user.name, body);
        apiFetchJson('/api/upload/trainee/' + user.id + '/' + selectedSimulationID + '/MOVIE', {
            method: 'POST',
            body: body,
            timeout: 0,
        })
            .then(data => {
                console.log('Return from movie submit', data);
                setStatus(data.status);
                setMessage(data.message);
                setSubmitting(false);
                authDispatch({
                    type: "UPDATE",
                    payload: data
                });
                // setShowToast(true);
            })
            .catch(error => {
                console.log(error);
                setSubmitting(false);
            })
    }

    const changeSimSelect = (simSelVal) => {
        if (Number.isInteger(simSelVal) || (typeof simSelVal === 'string' && Number.isInteger(parseInt(simSelVal, 10)))) {
            setIsSimSelected(true);
            setSelectedSimulation(simSelVal);
        } else {
            setIsSimSelected(false);
        }
        console.log("Selector change: ", simSelVal, isSimSelected);
    }

    
    // const handleDeleteMovie = event => {
    //     event.preventDefault();
    //     setSubmitting(true);

    //     // console.log('deleting movie for ', user.name);
    //     fetch('/api/data_delete/trainee/' + simulation.id + '/MOVIE', {
    //         method: 'GET',
    //     })
    //         .then(res => res.json()).then(data => {
    //             console.log('Return from movie delete', data);
    //             setStatus(data.status);
    //             toggleToast();
    //             setMessage(data.message);
    //             setSubmitting(false);
    //             authDispatch({
    //                 type: "UPDATE",
    //                 payload: data
    //             });
    //         })
    //         .catch(error => {
    //             console.log(error);
    //             setSubmitting(false);
    //         })
    // }


    return (
        <Container className="container">
            <h1>Upload simulation movies</h1>
            <div>
                <div className="col-lg-5 border border-dark mx-1 mb-5">
                    <Form onSubmit={handleSubmitMovie} disabled={submitting} encType='multiprt/form-data' className='m-1'>
                        <Form.Group >

                            <Form.Group as={Col} controlId="formGridCFDB">
                                <Form.Label>Simulation Name</Form.Label>
                                <Form.Select 
                                    size="sm" 
                                    id={"SimMovieSelect" + study.studyID} 
                                    onChange={(event) => changeSimSelect(event.target.value)} >
                                    <option key="SimulationMovie" value={null}>Choose Simulation Matching Movie</option>
                                    {study.simulations.map(
                                        (iSimulation) =>
                                            (iSimulation.trainee_id === user.id) && (
                                                <option key={'SimulationMovie' + iSimulation.simulationID} value={iSimulation.id}>{iSimulation.simulationID}</option>
                                            )
                                    )}
                                </Form.Select>
                            </Form.Group>


                            <Form.Label>
                                {submitting ? <span>Uploading, please wait</span> : <span>{message}</span>}
                                <Form.Control type="file" id="movieFileUpload" name="movie" />
                            </Form.Label>
                        </Form.Group>
                        <Button type="submit" disabled={!isSimSelected || submitting}>
                            Upload
                        </Button>
                    </Form>
                </div>

                <Toast className='mb-5' onClose={toggleToast} show={showToast}>
                    <Toast.Header>
                        <strong className="me-auto">STATUS: {status}</strong>
                    </Toast.Header>
                    <Toast.Body>{message}</Toast.Body>
                </Toast>
            </div>

        </Container>
    );
}

export default SimulationMovieUpload;